import script from "./WatermarkOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./WatermarkOverlay.vue?vue&type=script&setup=true&lang=js"

import "./WatermarkOverlay.vue?vue&type=style&index=0&id=1056cec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1056cec6"]])

export default __exports__